var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('v-breadcrumbs',{attrs:{"items":_vm.breadCrumbs,"large":""}}),_c('log')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }